export default "__VITE_ASSET__BdJ0PxGf__"